import {Component} from 'react';
import React from 'react';
import ReactTable from 'react-table';
import "react-table/react-table.css";
import request from 'request-promise-native';
import ValidatedFormComponent from "./ValidatedFormComponent";

class AzureTable extends Component {
    constructor(props) {
        /*
            Props:
                - access_code

                - additionalData

                - logout

                - onLoad
                - columns
                - defaultSorted
                - pageSize
                - SubComponent
                - getTdProps

                - functionUrl

                - tableRef
        */
        super(props);

        this.state = {
            data: null,
            loading: true,

            tableLoading: false,
            pages: 1,
            page: 0
        };

        this.pageCache = null;

        this.currentOrderDesc = null;
        this.currentOrderParam = null;

        this.lastState = null;

        if (this.props.tableRef != null) {
            this.props.tableRef({
                resetTable: this.resetTable.bind(this),
                getAllData: this.getAllData.bind(this),
                isEverythingLoaded: this.isEverythingLoaded.bind(this),
                getAllDataCount: this.getAllDataCount.bind(this)
            });
        }

    }

    isEverythingLoaded() {
        return !!this.last;
    }

    getAllData() {
        const arr = [];
        for (let page of this.pageCache) {
            for (let row of page) {
                arr.push(row);
            }
        }
        return arr;
    }

    getAllDataCount() {
        let i = 0;
        for (let page of this.pageCache) {
            i+=page.length;
        }
        return i;
    }


    resetTable() {
        this.pageCache = null;
        this.last = false;
        this.setState({
            page: 0
        },() => {
            this.fetchData.bind(this)(this.lastState);
        });
    }

    async fetchData(state,instance) {
        console.log("State: ",state);
        console.log("Instance: ",instance);

        if(state.loading) return;

        const sort = state.sorted[0];

        this.lastState = state;

        console.log("Sort:",sort);

        console.log("Filter:",state.filtered);

        const filter = state.filtered;

        if(sort.desc!==this.currentOrderDesc || sort.id!==this.currentOrderParam || !(this.lastFiltered.length==filter.length && this.lastFiltered.every(function(u, i) {
            return JSON.stringify(u) === JSON.stringify(filter[i]);
        })) ) {
            this.currentOrderDesc = sort.desc;
            this.currentOrderParam = sort.id;
            this.pageCache = null;
            this.setState({
                page: 0
            });
        }

        this.lastFiltered = filter;

        console.log("Filter",filter);
        console.log("Last filter",this.lastFiltered);

        this.setState({
            tableLoading: true
        });

        if(this.pageCache==null) {

            const sendBody = {
                access_code: this.props.access_code,

                orderParam: this.currentOrderParam,
                orderDescending: this.currentOrderDesc,

                search: state.filtered
            };

            if(this.props.additionalData!=null) for(let p in this.props.additionalData) {
                sendBody[p] = this.props.additionalData[p];
            }

            const options = {
                method: 'POST',
                uri: this.props.functionUrl,
                body: sendBody,
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            console.log("Sending request: ",options);

            const response = await request(options);

            console.log("Response: ",response);

            if(response.statusCode!=200) {
                console.log('Logging out!');
                this.props.logout();
                return;
            }

            if(this.props.onLoad!=null) this.props.onLoad();

            this.pageCache = [];
            if(response.body!=null) this.pageCache[0] = response.body;

            if(response.body==null || response.body[0]==null || response.body[0].last) {
                this.setState({
                    data: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 1
                });
                this.last = true;
            } else {
                this.setState({
                    data: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 2
                });
            }

            console.log("Data request success", response.body);
        } else {
            if(this.pageCache[instance.state.page]!=null) {
                this.setState({
                    data: this.pageCache[instance.state.page],
                    tableLoading: false,
                    loading: false
                });
            } else {

                let last = null;

                if(this.pageCache[instance.state.page-1]!=null) {
                    const page = this.pageCache[instance.state.page-1];
                    console.log("Page: "+(instance.state.page-1), page);
                    last = page[9][this.currentOrderParam];
                }
                console.log("Last: "+last);

                const sendBody = {

                    access_code: this.props.access_code,

                    orderParam: this.currentOrderParam,
                    orderDescending: this.currentOrderDesc,
                    last,

                    search: state.filtered
                };

                if(this.props.additionalData!=null) for(let p in this.props.additionalData) {
                    sendBody[p] = this.props.additionalData[p];
                }

                const options = {
                    method: 'POST',
                    uri: this.props.functionUrl,
                    body: sendBody,
                    json: true,
                    resolveWithFullResponse: true,
                    simple: false
                };

                const response = await request(options);

                if(response.statusCode!=200) {
                    console.log('Logging out!');
                    this.props.logout();
                    return;
                }

                if(response.body!=null) this.pageCache[instance.state.page] = response.body;

                if(response.body==null || response.body[0]==null || response.body[0].last) {
                    this.setState({
                        data: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: instance.state.page+1
                    });
                    this.last = true;
                } else {
                    this.setState({
                        data: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: instance.state.page+2
                    });
                }

                console.log("Data request success", response.body);
            }
        }

    }

    render() {

        const columnsCpy = [...this.props.columns];

        for(let c of columnsCpy) {
            if (c.notUseWhenNotPresent) {
                if (this.state.data == null || this.state.data.length === 0 || this.state.data[0] == null) {
                    console.log("Page size 0");
                    columnsCpy.splice(columnsCpy.indexOf(c), 1);
                } else {
                    console.log("Page size 0 accessor null");
                    if (this.state.data[0][c.accessor] == null) {
                        columnsCpy.splice(columnsCpy.indexOf(c), 1);
                    }
                }
            }
            if(c.filterable) {
                if(c.Filter==null) {
                    if (c.FilterOptions != null) {
                        c.Filter = (obj) => {
                            console.log(obj);
                            return (
                                <ValidatedFormComponent type="select"
                                                        onChange={(selectedVal) => {
                                                            //console.log("Changed to ", selectedVal);
                                                            obj.onChange(selectedVal);
                                                            console.log("onChange: ",selectedVal)
                                                            if(selectedVal != null && selectedVal !== '') {
                                                                this.setState({
                                                                    ["state" + c.accessor]: "success"
                                                                })
                                                            } else {
                                                                this.setState({
                                                                    ["state" + c.accessor]: null
                                                                })
                                                            }
                                                        }}
                                                        inputRef={(ref) => {
                                                            // ref._ref.onchange = (e) => {
                                                            // };
                                                            /*ref.onclick = (e) => {
                                                                obj.onChange(ref.value);
                                                                console.log("onChange: ",ref.value)
                                                                if(ref.value != null && ref.value !== '') {
                                                                    this.setState({
                                                                        ["state" + c.accessor]: "success"
                                                                    })
                                                                } else {
                                                                    this.setState({
                                                                        ["state" + c.accessor]: null
                                                                    })
                                                                }
                                                            }*/
                                                        }}
                                                        value={obj.filter==null ? "" : obj.filter.value}
                                                        options={c.FilterOptions}
                                                        value_key={"value"}
                                                        display_name_key={"display_name"}
                                                        validationState={this.state["state" + c.accessor]}
                                                        onValidate={() => null}/>
                            );
                        }
                    } else {
                        c.Filter = ({filter, onChange}) => {
                            return (
                                <ValidatedFormComponent type="text"
                                                        onChange={(val) => {
                                                            this.setState({
                                                                ["filterVal" + c.accessor]: val
                                                            })
                                                        }}
                                                        inputRef={(ref) => {
                                                            ref._ref.onkeydown = (e) => {
                                                                if (e.keyCode == 13) {
                                                                    onChange(ref.value);
                                                                    if (ref.value != null && ref.value !== '') {
                                                                        this.setState({
                                                                            ["state" + c.accessor]: "success"
                                                                        })
                                                                    } else {
                                                                        this.setState({
                                                                            ["state" + c.accessor]: null
                                                                        })
                                                                    }
                                                                }
                                                            };
                                                        }}
                                                        value={this.state["filterVal" + c.accessor] || ""}
                                                        validationState={this.state["state" + c.accessor]}
                                                        onValidate={() => null}/>
                            );
                        }
                    }
                }
            }
        }

        return (
            <ReactTable
                getTdProps={this.props.getTdProps}
                loading={this.state.tableLoading}
                SubComponent={this.props.SubComponent}
                data={this.state.data==null ? [] : this.state.data}
                columns={columnsCpy}
                defaultSorted={this.props.defaultSorted}
                manual
                pageText={""}
                ofText={""}
                renderCurrentPage={() => ""}
                renderTotalPagesCount={() => " "}
                pages={this.state.pages}
                page={this.state.page}
                onPageChange={(pageIndex) => this.setState({
                    page: pageIndex
                })}
                onFetchData={this.fetchData.bind(this)}
                showPageJump={false}
                showPageSizeOptions={false}
                defaultPageSize={10}
                className="-striped -highlight"
                collapseOnDataChange={false}
            />
        );
    }
}

export default AzureTable;